import type { BimActKc2OtherTotalItemData } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { ICellRendererParams } from 'ag-grid-community';

export const BimActKc2OtherTotalPriceCellRenderer = (
    props: ICellRendererParams<BimActKc2OtherTotalItemData, number>,
) => {
    const { value, data } = props;

    const isChecked = data?.workOrderActiveSeasonId === data?.workOrderSeasonId;

    return data?.isInflation ? <div>{isChecked && formatNumberToRu(value, 0)}</div> : formatNumberToRu(value, 0);
};

BimActKc2OtherTotalPriceCellRenderer.displayName = 'BimActKc2OtherTotalPriceCellRenderer';
